module.exports = __webpack_public_path__ + "2b925fa7.png";